module.exports = __webpack_public_path__ + "img/coach.dbdc3365.svg";